import { render } from "./WidgetImages.vue?vue&type=template&id=2e337e86"
import script from "./WidgetImages.vue?vue&type=script&lang=js"
export * from "./WidgetImages.vue?vue&type=script&lang=js"

import exportComponent from "/app/widget-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__